import { Collapse, Typography } from "antd";
import React from "react";
import CentralLine from "./CentralLine";
import PressureSore from "./PressureSore";
import Thrombo from "./Thrombo";

const PreventiveCare = ({ data }) => {
  const centralLineData = data?.data?.preventive_care_central_line_care;
  const thromboData = data?.data?.preventive_care_thromboprophylaxis;
  const pressureSoreData = data?.data?.preventive_care_pressure_sore_care;

  const hasCentralLine = centralLineData?.length > 0;
  const hasThrombo = thromboData?.length > 0;
  const hasPressureSore = pressureSoreData?.length > 0;

  if (!hasCentralLine && !hasThrombo && !hasPressureSore) {
    return (
      <div style={{ textAlign: "center", padding: "24px 0", color: "#98A2B3" }}>
        <Typography.Text type="secondary">No preventive care items</Typography.Text>
      </div>
    );
  }

  const defaultKeys = [];
  if (hasCentralLine) defaultKeys.push("1");
  if (hasThrombo) defaultKeys.push("2");
  if (hasPressureSore) defaultKeys.push("3");

  return (
    <div>
      <Collapse
        expandIconPosition="end"
        className="custom-collapse"
        style={{ marginTop: "10px" }}
        defaultActiveKey={defaultKeys}
      >
        {hasCentralLine && (
          <Collapse.Panel header="Central Line" key="1">
            <CentralLine data={centralLineData} />
          </Collapse.Panel>
        )}
        {hasThrombo && (
          <Collapse.Panel header="Thromboprophylaxis" key="2">
            <Thrombo data={thromboData} />
          </Collapse.Panel>
        )}
        {hasPressureSore && (
          <Collapse.Panel header="Pressure Sore Care" key="3">
            <PressureSore data={pressureSoreData} />
          </Collapse.Panel>
        )}
      </Collapse>
    </div>
  );
};

export default PreventiveCare;
